import React from 'react'

function RevisarEscopoOrcamento() {
  return (
    <div style={{padding: '10rem'}}>RevisarEscopoOrcamento</div>
  )
}

export default RevisarEscopoOrcamento
